import { render } from "./facility-photo.vue?vue&type=template&id=1021eb60&scoped=true"
import script from "./facility-photo.vue?vue&type=script&lang=js"
export * from "./facility-photo.vue?vue&type=script&lang=js"

import "./facility-photo.vue?vue&type=style&index=0&id=1021eb60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1021eb60"]])

export default __exports__